<div class="bg-img-login w-100 d-inline-block h-100 position-absolute" [style.background]="'url(' + bgImage + ')'">
</div>

<div id="mySidenav" class="sidenav d-inline-block position-absolute h-100 p-3" [ngStyle]="{'width' : sideNavWidth }">
  <div class="d-flex mobile-alignment login-card-wrapper">
    <mat-card class="login-card p-0" [class.login-card-selector]="showSelector"
      [class.login-card-form]="!showSelector">
      <div class="login-card-header" *ngIf="showSelector">
        <h1 class="login-card-title">Seleccione un módulo</h1>
        <p class="login-card-subtitle">Elija la opción que corresponda a su perfil</p>
      </div>

      <div class="login-card-header" *ngIf="!showSelector">
        <h1 class="login-card-title">Bienvenido</h1>
        <p class="login-card-subtitle">
          {{ tipoFormulario === tipoLoginFormEnum.ADMINISTRACION ? 'Administración' : 'Autogestión' }}
        </p>
      </div>

      <div *ngIf="showSelector;else showLogin" class="selector-body">
        <app-login-selector (tipoFormularioEmit)="getTipoFormularioEmit($event)"></app-login-selector>
      </div>

      <ng-template #showLogin>
            <div class="login-form-host" [ngSwitch]="tipoFormulario">
          <div *ngSwitchCase="tipoLoginFormEnum.AUTOGESTION">
            <app-login-ingreso-autogestion (volverEmit)="volver()"></app-login-ingreso-autogestion>
          </div>

          <div *ngSwitchCase="tipoLoginFormEnum.ADMINISTRACION">
            <app-login-ingreso-administracion (volverEmit)="volver()" (toggleSpinnerEmit)="toggleSpinner($event)">
            </app-login-ingreso-administracion>
          </div>
        </div>

      </ng-template>

      <div class="card-footer">
        <a href="https://www.sniperbot.com.ar" target="_blank" rel="noopener noreferrer">
          SniperBot<sup>®</sup>
        </a>
      </div>



      <!--
      <app-login-recuperar-pass *ngIf="recuperaCuenta" (setIngresoLogin)="switchBoxLogin()"
        (toggleSpinnerEmit)="toggleSpinner($event)"></app-login-recuperar-pass> -->
    </mat-card>
  </div>
</div>
